// Cost Center Management Tooltips
export const costCenterTooltips = {
  // Cost Center Fields
  centerName: "The name of the cost center. Example: 'Marketing Department', 'Sales Team', 'IT Operations'",
  centerCode: "A unique identifier code for the cost center. Example: 'MKTG-001', 'SALES-001', 'IT-OPS-001'",
  centerDescription: "A brief description of the cost center's purpose and responsibilities",
  centerType: "The organizational level of the cost center: Department (major business unit), Division (sub-unit), Team (small group), or Custom",
  parentCenter: "The parent cost center in the organizational hierarchy. Leave as 'None' for top-level cost centers",
  annualBudget: "The total annual budget allocated to this cost center in USD",
  centerManager: "The person responsible for managing this cost center and its budget",
  
  // Cost Allocation Fields
  allocationCostCenter: "Select which cost center will receive this budget allocation",
  allocationType: "Choose how to allocate the budget:\n• Fixed Amount: Allocate a specific dollar amount\n• Percentage: Allocate a percentage of the total budget",
  allocationAmount: "The dollar amount to allocate to this cost center. This will count towards the center's budget utilization",
  allocationPercentage: "The percentage of total budget to allocate. Example: Enter '25' for 25% of the budget",
  allocationDescription: "Optional notes about this allocation, such as purpose, project name, or time period",
  
  // Strategic Framework Linking
  linkedObjective: "Link this allocation to a strategic objective to track how budget supports strategic goals",
  linkedInitiative: "Link to a specific initiative that this allocation will fund",
  linkedRevenueStream: "Link to a revenue stream that this allocation is expected to support or enable",
  
  // Budget Management
  budgetPeriod: "Choose the time period for budget tracking: Annual (full year) or Quarterly (by quarter)",
  budgetUtilization: "Shows how much of the allocated budget has been used. Calculated from all allocations to this cost center",
  remainingBudget: "The amount of budget still available for allocation. This is Budget - Allocated Amount",
  
  // Analytics
  costCenterHierarchy: "Visual representation of your cost center organizational structure showing parent-child relationships",
  allocationByCenter: "Distribution of budget allocations across all cost centers",
  budgetVariance: "The difference between allocated budget and actual allocations. Positive variance means under-allocated, negative means over-allocated"
};

// Field requirement indicators
export const fieldRequirements = {
  centerName: { required: true, minLength: 2, maxLength: 100 },
  centerCode: { required: true, minLength: 2, maxLength: 50, pattern: /^[A-Z0-9-]+$/ },
  centerDescription: { required: false, maxLength: 500 },
  annualBudget: { required: false, min: 0 },
  allocationAmount: { required: true, min: 0.01 },
  allocationPercentage: { required: true, min: 0.01, max: 100 }
};

// Help text for complex operations
export const helpText = {
  hierarchySetup: "Set up your organizational hierarchy by creating parent cost centers first, then add child centers. This enables roll-up reporting and budget aggregation.",
  allocationStrategy: "Allocate budgets using either fixed amounts or percentages. Fixed amounts provide precise control, while percentages automatically adjust if the total budget changes.",
  strategicAlignment: "Link allocations to your strategic framework to track how spending aligns with organizational goals and measure ROI on strategic initiatives.",
  budgetTracking: "Monitor budget utilization in real-time. The system calculates how much of each center's budget has been allocated, helping prevent over-spending."
};
